import loading from './src/main.js';
export default loading;
